import { getUsageLimitsHelpUrl } from '@/components/constants/billing-urls';
import {
  useIsHeidi2OptInEnabled,
  useIsHeidi2PricingPlansModalEnabled,
  useIsHeidi2TrialEndEnabled,
} from '@/features/flags';
import { IS_EVIDENCE_LAUNCH_TRIAL_AND_UPGRADE_FLOWS_ENABLED } from '@/features/flags/legacy-flags';
import {
  trackComplimentaryTrialEndModalClick,
  trackComplimentaryTrialEndModalViewed,
} from '@/models/analytics/features/complimentary-trial-end-analytics';
import { isAppleCompliantBuild } from '@/utils/appConfiguration';
import {
  ComplimentaryTrialEndModal,
  type ComplimentaryTrialEndModalPorts,
} from '@heidi/commerce';

import {
  getOfferConditionsUrl,
  useOpenBillingSettings,
  useOpenClinicianCheckout,
} from './clinician-upgrade-checkout-route';

// The pricing plans modal is gated by its own rollout flag and only mounted
// with the Evidence trial-and-upgrade flows, as in the cloud-only modal tree.
const useIsPricingPlansModalAvailable = () =>
  useIsHeidi2PricingPlansModalEnabled() &&
  !!IS_EVIDENCE_LAUNCH_TRIAL_AND_UPGRADE_FLOWS_ENABLED();

const COMPLIMENTARY_TRIAL_END_MODAL_PORTS: ComplimentaryTrialEndModalPorts = {
  useIsHeidi2OptInEnabled,
  useIsHeidi2TrialEndEnabled,
  useIsPricingPlansModalAvailable,
  useOpenClinicianCheckout,
  useOpenBillingSettings,
  isAppleCompliantBuild,
  getUsageLimitsHelpUrl,
  getOfferConditionsUrl,
  trackComplimentaryTrialEndModalViewed,
  trackComplimentaryTrialEndModalClick,
};

/** Global mount for the T-7 complimentary usage end modal; it self-gates on its open atom. */
export const ComplimentaryTrialEndModalHost = () => (
  <ComplimentaryTrialEndModal ports={COMPLIMENTARY_TRIAL_END_MODAL_PORTS} />
);
